var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgDeezerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 478,
    viewBox: "0 .044 1000 191.2",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(1.8318 0 0 -1.8318 381.813 477.953)",
    gradientUnits: "userSpaceOnUse",
    x1: -111.722,
    x2: -111.943,
    y1: 241.804,
    y2: 255.826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#358c7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#33a65e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(1.8318 0 0 -1.8318 381.813 477.953)",
    gradientUnits: "userSpaceOnUse",
    x1: -123.891,
    x2: -99.772,
    y1: 223.628,
    y2: 235.917
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#222b90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367b99"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1.8318 0 0 -1.8318 381.813 477.953)",
    gradientUnits: "userSpaceOnUse",
    x1: -208.432,
    x2: -185.032,
    y1: 210.773,
    y2: 210.773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(1.8318 0 0 -1.8318 381.813 477.953)",
    gradientUnits: "userSpaceOnUse",
    x1: -180.132,
    x2: -156.732,
    y1: 210.773,
    y2: 210.773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc1953"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientTransform: "matrix(1.8318 0 0 -1.8318 381.813 477.953)",
    gradientUnits: "userSpaceOnUse",
    x1: -151.832,
    x2: -128.432,
    xlinkHref: "#e",
    y1: 210.773,
    y2: 210.773
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientTransform: "matrix(1.8318 0 0 -1.8318 381.813 477.953)",
    gradientUnits: "userSpaceOnUse",
    x1: -123.56,
    x2: -100.16,
    y1: 210.773,
    y2: 210.773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#222b90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3559a6"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientTransform: "matrix(1.8318 0 0 -1.8318 381.813 477.953)",
    gradientUnits: "userSpaceOnUse",
    x1: -152.756,
    x2: -127.508,
    xlinkHref: "#e",
    y1: 226.081,
    y2: 233.464
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientTransform: "matrix(1.8318 0 0 -1.8318 381.813 477.953)",
    gradientUnits: "userSpaceOnUse",
    x1: -180.965,
    x2: -155.899,
    y1: 234.334,
    y2: 225.211
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce1938"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientTransform: "matrix(1.8318 0 0 -1.8318 381.813 477.953)",
    gradientUnits: "userSpaceOnUse",
    x1: -178.165,
    x2: -158.699,
    y1: 257.754,
    y2: 239.791
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#ffd100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd5a22"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m234.1 126.944c0 40.1 24.7 64.1 61.4 64.1 18.3 0 33.7-5.1 42.3-18.5v18.5h33.5v-191h-34.8v81.2c-7.9-13.4-22.5-19.4-40.8-19.4-35.8-.1-61.6 24.4-61.6 65.1zm103.5 0c0 22.9-15.6 37.2-34.3 37.2-19.4 0-34.3-14.3-34.3-37.2 0-23.3 15-37.9 34.3-37.9 18.7 0 34.3 14.8 34.3 37.9zm142 14.8c-4 14.8-14.1 22.2-30 22.2-18.5 0-33.7-11.2-34.1-31h87.7c1.1-4.9 1.6-10.1 1.6-15.8 0-35.5-24.2-55.5-59.9-55.5-38.1 0-64.3 27.1-64.3 63.9 0 41 28.9 65.6 68.9 65.6 30.2 0 50.7-12.6 59.7-37.7zm-64.1-32c3.3-14.3 15.2-22.7 29.5-22.7 15.6 0 26.2 8.4 26.2 21.6l-.2 1.1zm193.2 32c-4 14.8-14.1 22.2-30 22.2-18.5 0-33.7-11.2-34.1-31h87.7c1.1-4.9 1.6-10.1 1.6-15.8 0-35.5-24.2-55.5-59.9-55.5-38.1 0-64.3 27.1-64.3 63.9 0 41 28.9 65.6 68.9 65.6 30.2 0 50.7-12.6 59.7-37.7zm-64.1-32c3.3-14.3 15.2-22.7 29.5-22.7 15.6 0 26.2 8.4 26.2 21.6l-.2 1.1zm212.1 81.5v-31.5h-73.1l71.1-69.2v-28.8h-112.5v30h68.7l-70.9 69.5v30zm101.7-49.5c-4 14.8-14.1 22.2-30 22.2-18.5 0-33.7-11.2-34.1-31h87.7c1.1-4.9 1.6-10.1 1.6-15.8 0-35.5-24.2-55.5-59.9-55.5-38.1 0-64.3 27.1-64.3 63.9 0 41 28.9 65.6 68.9 65.6 30.2 0 50.7-12.6 59.7-37.7zm-64.1-32c3.3-14.3 15.2-22.7 29.5-22.7 15.6 0 26.2 8.4 26.2 21.6l-.2 1.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m155.5 61.744h42.9v25.1h-42.9z",
    fill: "#40ab5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.5 9.7h42.9v25.1h-42.9z",
    fill: "url(#a)",
    transform: "translate(0 86.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.5 44.5h42.9v25.1h-42.9z",
    fill: "url(#b)",
    transform: "translate(0 86.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 79.3h42.9v25.1h-42.9z",
    fill: "url(#c)",
    transform: "translate(0 86.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.8 79.3h42.9v25.1h-42.9z",
    fill: "url(#d)",
    transform: "translate(0 86.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.7 79.3h42.9v25.1h-42.9z",
    fill: "url(#f)",
    transform: "translate(0 86.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.5 79.3h42.9v25.1h-42.9z",
    fill: "url(#g)",
    transform: "translate(0 86.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.7 44.5h42.9v25.1h-42.9z",
    fill: "url(#h)",
    transform: "translate(0 86.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.8 44.5h42.9v25.1h-42.9z",
    fill: "url(#i)",
    transform: "translate(0 86.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.8 9.7h42.9v25.1h-42.9z",
    fill: "url(#j)",
    transform: "translate(0 86.844)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m966.1 106.444v3.7h33.9v-9.9c0-22.2-13.9-38.3-37.2-38.3-15 0-25.6 7.3-31.1 19.4v-19.4h-35v129.3h35v-83.3c0-13.2 7.1-20.5 18-20.5 10 .1 16.4 9.5 16.4 19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeezerLogo);
export default __webpack_public_path__ + "static/media/img-deezer-logo.5b84003bf062220f667578cdd1e573ed.svg";
export { ForwardRef as ReactComponent };